import React from "react";
import { Avatar, Box, IconButton, Paper, Typography } from "@mui/material";
import CameraAltOutlinedIcon from "@mui/icons-material/CameraAltOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import VerifiedOutlinedIcon from "@mui/icons-material/VerifiedOutlined";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";

export default function ClientHeader({ organization = {} }) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        borderRadius: "12px",
        border: "1px solid #E5E7EB",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        minHeight: 140,
      }}
    >
      {/* Left Section */}

      <Box display="flex" alignItems="center">
        {/* Logo */}

        <Box position="relative">
          <Avatar
            variant="rounded"
            src={organization?.brandLogo || organization?.profilePhoto}
            sx={{
              width: 76,
              height: 76,
              bgcolor: "#EF4444",
              fontWeight: 700,
              fontSize: 26,
              borderRadius: 2,
            }}
          >
            {organization?.name?.charAt(0)}
          </Avatar>

          <IconButton
            size="small"
            sx={{
              position: "absolute",
              bottom: -8,
              right: -8,
              bgcolor: "#fff",
              border: "1px solid #E5E7EB",
              width: 28,
              height: 28,

              "&:hover": {
                bgcolor: "#F9FAFB",
              },
            }}
          >
            <CameraAltOutlinedIcon sx={{ fontSize: 15 }} />
          </IconButton>
        </Box>

        {/* Company Info */}

        <Box ml={3}>
          <Typography
            sx={{
              fontSize: 30,
              fontWeight: 700,
              color: "#2b2b2b",
            }}
          >
            {organization?.name || "-"}
          </Typography>

          <Box
            mt={1}
            display="flex"
            flexWrap="wrap"
            gap={4}
            alignItems="center"
          >
            <Box display="flex" alignItems="center">
              <LocationOnOutlinedIcon
                sx={{
                  fontSize: 17,
                  color: "#2F80ED",
                  mr: 0.5,
                }}
              />

              <Typography
                sx={{
                  fontSize: 14,
                  color: "#2b2b2b",
                  maxWidth: 320,
                  fontWeight: 400,
                }}
              >
                {organization?.organizationAddress || "-"}
              </Typography>
            </Box>

            <Box display="flex" alignItems="center">
              <VerifiedOutlinedIcon
                sx={{
                  fontSize: 17,
                  color: "#2F80ED",
                  mr: 0.5,
                }}
              />

              <Typography
                sx={{
                  fontSize: 14,
                  color: "#2b2b2b",
                  fontWeight: 400,
                }}
              >
                {organization?.isAnnualPartner ? "Annual Partner" : "Partner"}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>

      {/* Right Section */}

      <Box
        sx={{
          opacity: 0.08,
          display: {
            xs: "none",
            md: "block",
          },
        }}
      >
        <BusinessOutlinedIcon
          sx={{
            fontSize: 110,
            color: "#98A2B3",
          }}
        />
      </Box>
    </Paper>
  );
}
